import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Alert, Button, ControlLabel, FormControl, FormGroup} from 'react-bootstrap';
import {Link, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {onLogin} from '../actions/AccountActions';
import {extractErrorMessage} from '../utils';

@connect(state => ({isAuthenticating: state.auth.isAuthenticating, isAuthenticated: state.auth.isAuthenticated, error: state.auth.error}), {onLogin})
export default class Login extends Component {
    static propTypes = {
        isAuthenticating: PropTypes.bool,
        onLogin: PropTypes.func,
        error: PropTypes.any,
        isAuthenticated: PropTypes.bool,
        location: PropTypes.shape({
            state: PropTypes.shape({
                savedLocation: PropTypes.shape({
                    pathname: PropTypes.string
                })
            })
        })
    };

    handleLogin = (e) => {
        e.preventDefault();
        const email = this.email.value;
        const password = this.password.value;
        this.props.onLogin({email, password});
    };

    render() {
        const {error, isAuthenticating, isAuthenticated, location} = this.props;

        if (!error && isAuthenticated) {
            const {savedLocation} = location.state || {};
            return <Redirect to={savedLocation || {pathname: '/images/my'}}/>;
        }

        return (
            <div className="page">
                <div className="page_contents">
                    <div className="card">
                        <form className="login">
                            <h1>{'Login'}</h1>
                            <p>{'Login to your account.'}</p>
                            {error ? <Alert bsStyle="danger">{extractErrorMessage(error)}</Alert> : null}
                            <FormGroup>
                                <ControlLabel>{'Email'}</ControlLabel>
                                <FormControl
                                    inputRef={ c => this.email = c }
                                    type="text"
                                    placeholder="Enter email"
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>{'Password'}</ControlLabel>
                                <FormControl
                                    inputRef={ c => this.password = c }
                                    type="password"
                                    placeholder="Enter password"
                                />
                            </FormGroup>
                            <Button type="submit" className="loginBtn" bsStyle="primary" onClick={this.handleLogin} disabled={isAuthenticating}>{'LOGIN'}</Button>
                            <Link to="/register"><Button className="registerBtn">{'REGISTER'}</Button></Link>
                            <Link to="/forgotPassword">{'Forgot password'}</Link>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js